;$(function() {

	page = {};
	page.selects = $('.select2');

	page.selects.select2({
		width: '100%',
		minimumResultsForSearch: Infinity
	});


})